var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isPluginEditionFree(_vm.edition))?[(
        _vm.licensedEdition &&
        _vm.licensedEdition.handle !== _vm.edition.handle &&
        _vm.licensedEdition.price > 0 &&
        _vm.licenseValidOrAstray
      )?[_c('del',[_vm._v(_vm._s(_vm._f("currency")(_vm.edition.price)))]),_vm._v("\n      "+_vm._s(_vm._f("currency")((_vm.edition.price - _vm.licensedEdition.price)))+"\n    ")]:[_vm._v("\n      "+_vm._s(_vm._f("currency")(_vm.edition.price))+"\n    ")]]:[_vm._v("\n    "+_vm._s(_vm._f("t")('Free','app'))+"\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }